export default {
  'apiCallSend.title': 'Mapeos Envío API',

  'apiCallSend.form.valueSource': 'Origen Valor',
  'apiCallSend.form.form': 'Formulario',
  'apiCallSend.form.field': 'Campo',
  'apiCallSend.form.variable': 'Variable',
  'apiCallSend.form.formula': 'Formula',
  'apiCallSend.form.fixedValue': 'Valor Fijo',
  'apiCallSend.form.internalField': 'Campo Interno',
  'apiCallSend.form.tableParameterName': 'Nombre Parámetro Lista',
  'apiCallSend.form.parameterName': 'Nombre Parámetro',
  'apiCallSend.form.sendParameterPosition': 'Ubicación de Envío',
  'apiCallSend.form.parameterCodification': 'Codificación Parámetro',

  'apiCallSend.form.select.FormField': 'Formulario / Campo',
  'apiCallSend.form.select.Variable': 'Variable',
  'apiCallSend.form.select.Formula': 'Formula',
  'apiCallSend.form.select.FixedValue': 'Valor Fijo',
  'apiCallSend.form.select.InternalField': 'Campo Interno',
  'apiCallSend.form.select.IterationStepData': 'Iteración / Datos',
  'apiCallSend.form.select.GeneratedDocument': 'Documento Generado',

  'apiCallSend.form.select.FieldValue': 'Valor a Mostrar',
  'apiCallSend.form.select.FieldSearchValue': 'Valor de Búsqueda',

  'apiCallSend.form.select.None': 'Sin Codificación',
  'apiCallSend.form.select.ByteArray': 'Arreglo de Bytes',
  'apiCallSend.form.select.Base64String': 'Cadena Base64',
  'apiCallSend.form.select.ZipByteArray': 'Fichero Zip - Arreglo de Bytes',
  'apiCallSend.form.select.ZipBase64String': 'Fichero Zip - Cadena Base64',
  'apiCallSend.form.select.HttpBodyBinaryData': 'Binario Codificado en Cuerpo de la Petición',

  'apiCallSend.form.select.Header': 'Cabecera',
  'apiCallSend.form.select.Url': 'Url',
  'apiCallSend.form.select.FormData': 'Datos del formulario',
  'apiCallSend.form.select.BodyJson': 'Cuerpo(JSON)',
  'apiCallSend.form.select.XWwwFormUrlEncoded': 'Formulario Url Codificada',
  'apiCallSend.form.select.Authorization': 'Autorización',
  'apiCallSend.form.select.BodyText': 'Cuerpo de Texto',

  'apiCallSend.form.select.ProcessIdentifier': 'Proceso - Identificador Interno',
  'apiCallSend.form.select.ProcessName': 'Proceso - Nombre',
  'apiCallSend.form.select.ProcessGroupName': 'Grupo de Proceso - Nombre',
  'apiCallSend.form.select.InstanceName': 'Solicitud - Nombre',
  'apiCallSend.form.select.InstanceCreated': 'Solicitud - Fecha de Creación',
  'apiCallSend.form.select.InstanceStatus': 'Solicitud - Estado',
  'apiCallSend.form.select.ApplicantFullName': 'Solicitante - Nombre Completo',
  'apiCallSend.form.select.InstanceApprovedDate': 'Solicitud - Fecha de Aprobación',
  'apiCallSend.form.select.InstanceRejectedDate': 'Solicitud - Fecha de Rechazo',
  'apiCallSend.form.select.ApplicantNames': 'Solicitante - Nombres',
  'apiCallSend.form.select.ApplicantEmail': 'Solicitante - Correo',
  'apiCallSend.form.select.ApplicantPosition': 'Solicitante - Puesto',
  'apiCallSend.form.select.InstanceIdentifier': 'Solicitud - Identificador Interno',
  'apiCallSend.form.select.InstanceLastInstanceRejectUsers':
    'Solicitud - Usuarios Rechazadores Último Paso',
  'apiCallSend.form.select.InstanceLastInstanceApproversUsers':
    'Solicitud - Usuarios Aprobadores Último Paso',
  'apiCallSend.form.select.InstanceRejectedReason': 'Solicitud - Motivo Rechazo',
  'apiCallSend.form.select.InstanceApprovalRemarks': 'Solicitud - Observaciones Aprobación',
  'apiCallSend.form.select.InstanceCancellationDate': 'Solicitud - Fecha de Cancelación',
  'apiCallSend.form.select.InstanceCancellationReason': 'Solicitud - Motivo de Cancelación',
  'apiCallSend.form.select.InstanceDetailsViewUrl': 'Solicitud - Url Vista Detalles',
};
